import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";
import * as z from "zod";

export const resetPasswordSchema = z.object({
  token: z.string().min(1, "Necesita navegar a la página desde su correo electrónico con el enlace de restablecimiento de contraseña"),
  password: z
    .string()
    .trim()
    .min(1, "La contraseña es requerida")
    .min(6, "La contraseña debe tener al menos 6 caracteres"),
  confirmPassword: z
    .string()
    .trim()
    .min(1, "La confirmación de contraseña es requerida"),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Las contraseñas no coinciden",
  path: ["confirmPassword"],
});

export type ResetPasswordRequest = z.infer<typeof resetPasswordSchema>;

export async function resetPassword(request: Pick<ResetPasswordRequest, 'token' | 'password'>): Promise<Response<string>> {
  const responseResult = await tryCatch(fetch(`${API_BASE_URL}/api/v1/resetear-contrasena`, {
    method: 'PATCH',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  }));

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err ? 
      Err({
        message: `Error al restablecer contraseña: ${errorMessageResult.val.message}`,
        devMessage: errorMessageResult.val.message,
      }) : 
      Err({
        message: errorMessageResult.val.message,
        devMessage: errorMessageResult.val.devMessage,
      });
  }

  const dataResult = await tryCatch(response.text());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
} 